import CardAuthor from './CardElements/CardAuthor';
import CardCategory from './CardElements/CardCategory';
import CardSocials from './CardElements/CardSocials';

import Button from './CustomButton/CustomButton';

import Footer from './Footer/Footer';

import FormInputs from './FormInputs/FormInputs';

import Header from './Header/Header';

import PanelHeader from './PanelHeader/PanelHeader';

import Sidebar from './Sidebar/Sidebar';

import Stats from './Stats/Stats';


export {
    // CardElements
    CardAuthor,
    CardCategory,
    CardSocials,
    // CustomButton
    Button,
    // Footer
    Footer,
    // FormInputs
    FormInputs,
    // Header
    Header,
    // PanelHeader
    PanelHeader,
    // Sidebar
    Sidebar,
    // Stats
    Stats,
};



// WEBPACK FOOTER //
// ./src/components/index.js